<script>
  import { onMount } from 'svelte'
  import Reviewer from '../components/ReviewerProfile/Reviewer.svelte'
  import ReviewerImage from '../components/ReviewerProfile/ReviewerImage.svelte'
  import DateChannel from '../components/DateChannel/DateChannel.svelte'
  import Rating from '../components/Rating.svelte'
  import Modal from '../components/Modal.svelte'
  import SliderModalContent from './ReviewsContent/SliderModalContent.svelte'
  import Date from '../components/Date.svelte'
  import {
    capitalizeFirstLetter,
    handleTextContent,
    contentExceedsLimit,
    getNameBasedOnStyle
  } from '../utils'

  export let reviews
  export let settings
  export let isMobile

  let textColor
  let starColor
  let verifiedReviewerText
  let verifiedBuyerText
  let widgetNameColor
  let contentFontSize
  let readMoreTextColor
  let readMoreText
  let verifiedTextColor
  let profilePictureColor
  let cardColor
  let secondaryTextColor

  const charLimit = isMobile ? 50 : 100

  onMount(() => {
    contentFontSize =
      settings.widget_settings.general_settings.content_font_size
    textColor = settings.widget_settings.general_settings.text_colour
    starColor = settings.widget_settings.general_settings.star_rating_color
    verifiedReviewerText = capitalizeFirstLetter(
      settings.translations.verified_reviewer
    )
    verifiedBuyerText = capitalizeFirstLetter(
      settings.translations.verified_buyer
    )
    widgetNameColor =
      settings.widget_settings.general_settings.reviewer_name_text_color

    cardColor = settings.widget_settings.general_settings.card_color
    readMoreTextColor =
      settings.widget_settings.general_settings.secondary_text_color
    readMoreText = settings.translations.read_more_text
    verifiedTextColor =
      settings.widget_settings.general_settings.secondary_text_color
    profilePictureColor =
      settings.widget_settings.general_settings.profile_picture_color
    secondaryTextColor =
      settings.widget_settings.general_settings.secondary_text_color
  })
</script>

<style>
  .kbz_reviews_card {
    font-size: 14px;
    padding: 20px;
    width: 350px;
    max-width: 90%;
    flex-shrink: 0;
    height: 145px !important;
    background: var(--background);
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    position: relative;
    float: left;
    margin: 10px;
    overflow: hidden;
    text-align: left;
  }

  .kbz_reviews_card_body {
    display: flex;
    clear: both;
  }

  .kbz_reviews_card_header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  #reviewer-profile {
    margin-bottom: 12px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .review-content {
    line-height: 1.3;
    font-style: italic;
  }

  .right_column {
    width: 100%;
  }

  .date {
    color: #696c85;
    font-size: 12px;
  }

  @media only screen and (max-width: 400px) {
    #reviewer-profile {
      display: block;
      margin-bottom: 8px;
    }

    .kbz_reviews_card_header {
      margin-bottom: 8px;
    }
  }
</style>

{#each reviews as review, i (review.id)}
  <div
    role="group"
    aria-label={`review ${i}`}
    aria-roledescription="slide"
    class="$style.kbz_reviews_card"
    style="--background: {cardColor};">
    <ReviewerImage
      reviewerEmail={review.reviewer.email}
      reviewerImage={review.reviewer.image ? review.reviewer.image.profile_url : null}
      reviewerName={getNameBasedOnStyle({
        reviewer: review.reviewer,
        style: settings.widget_settings.general_settings.reviewer_name_style
      })}
      {profilePictureColor}
      isVerifiedBuyer={!!review.external_order_id}
      isVerifiedReviewer={review.reviewer.verified} />

    <div class="$style.right_column">
      <div id="reviewer-profile">
        <Reviewer
          {textColor}
          reviewerName={getNameBasedOnStyle({
            reviewer: review.reviewer,
            style: settings.widget_settings.general_settings.reviewer_name_style
          })}
          verifiedText={review.external_order_id ? verifiedBuyerText : verifiedReviewerText}
          isVerifiedBuyer={!!review.external_order_id}
          isVerifiedReviewer={review.reviewer.verified}
          {widgetNameColor}
          {verifiedTextColor} />
        <div class="$style.date">
          <Date
            {secondaryTextColor}
            date={review.created_at_platform}
            dateFormat={settings.widget_settings.general_settings.date_format} />
        </div>
      </div>
      <div class="$style.kbz_reviews_card_header">
        <div id="review-rating">
          <Rating {starColor} reviewrating={review.rating} />
        </div>
      </div>
      <div class="$style.kbz_reviews_card_body">
        {#if review.message && review.message.length !== 0}
          <Modal>
            <SliderModalContent
              reviewContent={review.message}
              reviewRating={review.rating}
              reviewerName={getNameBasedOnStyle({
                reviewer: review.reviewer,
                style:
                  settings.widget_settings.general_settings.reviewer_name_style
              })}
              reviewChannel={review.platform}
              reviewerEmail={review.reviewer.email}
              reviewerImage={review.reviewer.image ? review.reviewer.image.profile_url : null}
              {settings}
              reviewImages={review.images}
              reviewDate={review.created_at_platform}
              hasMoreContent={contentExceedsLimit(review.message, charLimit)}>
              <div
                id={review.account_id}
                class="$style.review-content"
                style={`color: ${textColor}; 
                font-size: ${contentFontSize}px;`}>
                {@html handleTextContent(review.message, charLimit, readMoreTextColor, readMoreText)}
              </div>
            </SliderModalContent>
          </Modal>
        {/if}
      </div>
      <DateChannel reviewchannel={review.platform} />
    </div>
  </div>
{/each}
